import * as React from 'react';
import styled, {css} from 'styled-components';
import { createVideoPreviewUrl } from '../../../cloudinary';
import Dialog from '../../../components/Dialog';
import camera from '../../../img/camera.svg';
import { ApplicationState } from '../../../types/api';
import { Candidate } from '../types';
import EditCandidateForm from './EditCandidateForm';
import sent from '../../../img/sent.svg'

interface VacancyCandidateState {
    showDataForm: boolean;
}

interface VacancyCandidateProps {
    candidate: Candidate;
    onUpdate: (candidate: Candidate) => void;
    onInvite: (candidate: Candidate) => void;
    onRemove: (candidate: Candidate) => void;
}

const Avatar = styled.img`
    height: 5em;
    margin-bottom: 0.4em;

    &:not([src$=".svg"]) {
        margin: -1em -1em 0.4em -1em;
        height: 6em;
    }
`;

const Wrapper = styled.div`
    position: relative;
`;

const Envelop = props => props.invited && css`

    &:after {
        position: absolute;
        content: url(${sent});
        height: 2em;
        width: 2em;
        right: .5em;
    }
`

interface Props {
    invited: boolean;
}

const Candidate = styled<Props, any>('div')`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 1em;
    padding: 1em 1em .5em 1em;
    border: 1px solid #ddd;
    border-radius: 5px;
    cursor: pointer;

    overflow: hidden;

    p {
        margin: 0;
    }

    &:hover, &:active, &:focus {
        color: white;
        background-color: ${props => props.theme.primary}
    }

    ${Envelop}
`;

class VacancyCandidate extends React.Component<VacancyCandidateProps, VacancyCandidateState> {
    constructor(props: VacancyCandidateProps) {
        super(props);
        this.state = { showDataForm: false };
        this.toggleShowDataForm = this.toggleShowDataForm.bind(this);
    }

    private toggleShowDataForm() {
        this.setState({ showDataForm: !this.state.showDataForm });
    }

    public render() {
        const candidate = this.props.candidate;
        return (
            <Wrapper>
                <Candidate onClick={this.toggleShowDataForm} invited={candidate.applicationState === ApplicationState.INVITATION_SENT}>
                    <Avatar src={getAvatarUrl(candidate)} />
                    <p>{candidate.firstname}</p>
                    <p>{candidate.lastname}</p>
                </Candidate>
                {this.state.showDataForm && (
                    <Dialog toggle={this.toggleShowDataForm}>
                        <EditCandidateForm
                            candidate={candidate}
                            onUpdate={this.props.onUpdate}
                            onInvite={this.props.onInvite}
                            onRemove={this.props.onRemove}
                        />
                    </Dialog>
                )}
            </Wrapper>
        );
    }
}

const getAvatarUrl = (candidate: Candidate) => {
    return candidate.videoReference ? createVideoPreviewUrl(candidate.videoReference, 'c_fill,g_auto,h_100,w_140') : camera;
};

export default VacancyCandidate;



// WEBPACK FOOTER //
// ./src/scenes/administrator/components/VacancyCandidate.tsx